import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/Frontend-web-next/src/components/legal/LegalPolicyPage.tsx");
